// extracted by mini-css-extract-plugin
module.exports = {"label":"AttributeAssigner_label__3793d","container":"AttributeAssigner_container__2nuIe"};